import RestResource from '../rest.service';

export default class CitiesService extends RestResource {
  constructor() {
    super('cities');
  }
}
